import { again } from '@dazn/bootstrap-lib';

import { captureException } from './captureException';
import { SafeModeParser } from './parseSafeModeStatus';

/**
 *  @see [Request](../../docs/api-call.md)
 */
export const fetchSafeMode = (
    fetch: typeof window.fetch,
    statusURL: string,
    parseResponse: SafeModeParser,
) =>
    again(() =>
        fetch(statusURL)
            .then(parseResponse)
            .catch(err => {
                captureException(err);
                throw err;
            }),
    );
